var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSylized2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.617188 10.9046C0.617188 4.88216 5.49907 3.24249e-05 11.5221 3.24249e-05C17.5439 3.24249e-05 22.4257 4.88216 22.4257 10.9046C22.4257 16.9269 17.5439 21.809 11.5221 21.809C5.49907 21.809 0.617188 16.9269 0.617188 10.9046Z",
    fill: "#EA8F4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30879 8.87557C8.30879 9.62346 7.94802 10.2299 7.50409 10.2299C7.06145 10.2299 6.70068 9.62346 6.70068 8.87557C6.70068 8.12768 7.06145 7.52116 7.50409 7.52116C7.94802 7.52116 8.30879 8.12768 8.30879 8.87557Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3427 8.87557C16.3427 9.62346 15.9832 10.2299 15.5393 10.2299C15.0953 10.2299 14.7358 9.62346 14.7358 8.87557C14.7358 8.12768 15.0953 7.52116 15.5393 7.52116C15.9832 7.52116 16.3427 8.12768 16.3427 8.87557Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61719 15.4999C8.95052 13.0405 13.1172 11.9999 15.6172 15.5",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSylized2);
export default __webpack_public_path__ + "static/media/sylized_2.ab9e05474bebf2f93be6abbec5687d5f.svg";
export { ForwardRef as ReactComponent };